import { observer } from "mobx-react-lite"
import useStore from "reusable/mobx-store-utils"
import { ConfigNumber } from "reusable/mobx-store-utils/form-handlers/new/form-handler"
import { useProposalsEditPaymentStore } from "../ProposalsEditPaymentStore"
import { ServiceRateTypeEnum } from "@gap/backend/app-services/services/models/ServiceRateTypesDto"
import { ProposalStep3AllExtraAttributesDto } from "@gap/backend/app-services/proposal/models/ProposalStep3Dto"
import { PickByValue } from "@gap/utils/utils"
import TextField from "@mui/material/TextField"
import InputAdornment from "@mui/material/InputAdornment"
import ProposalsEditPaymentBlockInputStore from "./ProposalsEditPaymentBlockInputStore"
import { useEffect } from "react"

type FieldName = keyof PickByValue<ProposalStep3AllExtraAttributesDto, number>
type FieldType = 'required' | 'optional' | 'disabled'

export interface ProposalsEditPaymentBlockInputProps {
   rateType: ServiceRateTypeEnum
   fieldName: FieldName
   formNumberConfig?: Partial<ConfigNumber>
   fieldType: FieldType
}

export default observer(function ProposalsEditPaymentBlockInput(props: ProposalsEditPaymentBlockInputProps) {
   const proposalEditPaymentStore = useProposalsEditPaymentStore()

   const proposalsEditPaymentBlockInputStore = useStore(sp => new ProposalsEditPaymentBlockInputStore(sp), {
      fieldName: props.fieldName,
      rateType: props.rateType,
      fieldType: props.fieldType,
      proposalEditPaymentStore
   })

   useEffect(() => {
      if (proposalsEditPaymentBlockInputStore.stepData) {
         proposalsEditPaymentBlockInputStore.fields.fieldValue = proposalsEditPaymentBlockInputStore.stepData[props.fieldName]
      }
   }, [proposalsEditPaymentBlockInputStore.fields, proposalsEditPaymentBlockInputStore.stepData, props.fieldName])

   if (!proposalsEditPaymentBlockInputStore.stepData) {
      return null
   }

   return proposalsEditPaymentBlockInputStore.formHandler.fieldValue.bindInput(ip =>
      <TextField
         disabled={props.fieldType === 'disabled'}
         InputProps={{
            endAdornment: <InputAdornment position="end" sx={{ opacity: props.fieldType === 'disabled' ? 0.5 : 1 }}>%</InputAdornment>
         }}
         variant='outlined'
         label={proposalsEditPaymentBlockInputStore.fieldLabel}
         sx={{ width: '134px', opacity: props.fieldType === 'disabled' ? 0.5 : 1 }}
         {...ip}
      />
   )
})
